import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { PSTasacionModel } from '../../../models/ps-tasacion-model';
import { ModelHelpers } from '../../../models/ModelHelpers';
import { PsTasacionService } from '../../../services/ps-tasacion.service';
import { ErrorHelper } from '../../../models/ErrorHelper';
import { ControlLookupComponent } from '../../control-lookup/control-lookup.component';
import { PsDatosGeneralesService } from '../../../services/ps-datos-generales.service';
import { PsDatosGeneralesListComponent } from '../../proyectos-significativos/ps-datos-generales-list/ps-datos-generales-list.component';

@Component({
  selector: 'app-tasacion-edit-ps-form',
  templateUrl: './tasacion-edit-ps-form.component.html',
  styleUrls: ['./tasacion-edit-ps-form.component.scss']
})
export class TasacionEditPsFormComponent implements OnInit {
  formGroup: FormGroup;
  tasacionId: number;
  errorMessage: string = '';
  model: PSTasacionModel;

  @ViewChild('lookupPS', { static: false }) lookupPS: ControlLookupComponent;

  constructor(public dialogRef: MatDialogRef<TasacionEditPsFormComponent>, private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, private _avRoute: ActivatedRoute, public matDialog: MatDialog, private _psTasacionService: PsTasacionService,
    private _psService: PsDatosGeneralesService) {
    // console.log(data)
    if (data !== null) {
      this.tasacionId = data.id;
    }
  }

  ngOnInit() {
    this.buildForm();
    this.loadData();
    // this.formInit();
    // this.bindFromModel();
  }

  ngAfterViewInit(): void {
    if (this.lookupPS) {
      this.lookupPS.serviceSource = (query: string) => {
        return this._psService.getPSLookup(query);
      };
      this.lookupPS.serviceSourceById = (id: number) => {
        if (id != null) {
          return this._psService.getPSLookupId(id);
        }
      };

      this.lookupPS.advancedLookupComponent = PsDatosGeneralesListComponent;
    }
  }

  buildForm() {
    if (this.model === undefined) this.model = new PSTasacionModel();
    this.formGroup = this._fb.group({
      id: null,
      idps: null,
      tasacionId: [this.tasacionId]
    })
  }

  formInit() {
    // console.log(this.lookupPS)
    // if (this.lookupPS) {
    this.lookupPS.serviceSource = (query: string) => {
      return this._psService.getPSLookup(query);
    };
    this.lookupPS.serviceSourceById = (id: number) => {
      return this._psService.getPSLookupId(id);
    };

    this.lookupPS.advancedLookupComponent = PsDatosGeneralesListComponent;
    // }
  }


  loadData() {
    if (this.tasacionId > 0) {
      this._psTasacionService.get(this.tasacionId).subscribe(
        (response: PSTasacionModel) => {
          if (response) {
            this.model = response;
          } else {
            this.model = new PSTasacionModel();
          }
          this.bindFromModel();
          // console.log(this.lookupPS)
          // this.formInit();
        },
        (error: any) => {
          this.errorMessage = ErrorHelper.GetClientError(error);
          console.error(this.errorMessage);
        }
      );
    }
  }

  bindFromModel() {
    this.formGroup.patchValue({
      id: this.model.id,
      idps: this.model.idps,
      tasacionId: this.tasacionId
    });
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.formGroup.value, this.model);
  }

  async onSubmit() {

    let result = null;

    if (!this.formGroup.valid)
      return

    this.bindToModel();

    if (this.tasacionId != 0) {
      if (this.formGroup.value != null) {
        try {
          if (this.model.idps == null || this.model.idps == ''
            || this.model.idps == undefined) {
            await this._psTasacionService.delete(this.model.id).toPromise();
          } else {
            await this._psTasacionService.post(this.model).toPromise()
          }
          result = true;
          this.closeDialog();
        } catch (error) {
          result = false;
          let errorMessage = ErrorHelper.GetClientError(error);
          this.errorMessage = errorMessage;
        }
      }
    }
    return result;
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

}
